import React from "react";
import {Typography, Tooltip} from "@mui/material";

export default function AssessmentStatusNotAvailable(props) {

    const {label} = props;

    return <Tooltip title={label}><Typography>—</Typography></Tooltip>;
}